import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zh_cn  from '../lang/zh-cn';
import en_us  from '../lang/en-us';
import zh from '../locales/zh-CN.json'
import en from '../locales/en-US.json'
import ElementLocale from 'element-ui/lib/locale'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import { setI18n } from '~/common/utils/i18n-helper'

ElementLocale.i18n((key, value) => i18n.t(key, value))
Vue.use(VueI18n)

const i18n =  new VueI18n({
    locale: 'zh-CN',
    fallbackLocale: 'zh-CN',
    silentTranslationWarn: true, // *解决不必要的国际化警告
    messages: {
      'en-US': { ...en_us,...enLocale,...en }, // 引入lang中创建的js文件
      'zh-CN': { ...zh_cn,...zhLocale, ...zh },
    }
  })
setI18n(i18n)
export default i18n

